var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29183 6.45834L6.5 8.25017L4.70817 6.45834L5.09167 6.07484L6.22917 7.20638V4.6665H6.77083V7.20638L7.90833 6.07484L8.29183 6.45834ZM5.54179 11.1459H7.45821V10.7288H5.54179V11.1459ZM4.12533 12.4167C3.87581 12.4167 3.66762 12.3333 3.50079 12.1664C3.33396 11.9996 3.25036 11.7914 3.25 11.5419V2.45813C3.25 2.20896 3.3336 2.00096 3.50079 1.83413C3.66799 1.66729 3.87617 1.5837 4.12533 1.58334H8.87521C9.12438 1.58334 9.33238 1.66693 9.49921 1.83413C9.66604 2.00132 9.74964 2.2095 9.75 2.45867V11.5419C9.75 11.791 9.66658 11.9992 9.49975 12.1664C9.33292 12.3336 9.12456 12.417 8.87467 12.4167H4.12533ZM3.79167 9.45809H9.20833V3.47917H3.79167V9.45809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoWhite);
export default __webpack_public_path__ + "static/media/promoWhite.e30b3956b7f77e968e15ac7f2fd8b8c7.svg";
export { ForwardRef as ReactComponent };